/**
 * Fire-and-forget log of an interaction with a company's network diagram
 * (POST /api/companies/{euId}/network/click → system log `network_click`).
 * Shared by the v1 diagram and the v2 network view; never throws.
 */
export interface NetworkClickPayload {
  subEvent?: 'fullscreen_open' | 'fullscreen_close' | 'filter_toggle';
  role?: string;
  checked?: boolean;
  source?: 'inline_overlay' | 'fullscreen_button' | 'filter_panel';
}

export function trackNetworkClick(euId: string, payload?: NetworkClickPayload): void {
  fetch(`/api/companies/${encodeURIComponent(euId)}/network/click`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload ?? {}),
  }).catch(() => {});
}
